export default __webpack_public_path__ + "static/media/home_page_banner.a0d3616e.jpg";